// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-page-url-details-___page-url-details__page-url-details___YeOQb {
  margin: 0.25em 0 0;
  padding: 0 1em;
}

.src-components-page-url-details-___page-url-details__page-url-details___YeOQb summary {
  cursor: pointer;
  margin-left: -1em;
}

.src-components-page-url-details-___page-url-details__page-url-details___YeOQb ins {
  font-weight: bold;
  background: none !important;
}

.src-components-page-url-details-___page-url-details__page-url-details___YeOQb a {
  /*
    Links here are full URLs are can sometimes have no good line break points.
  */
  line-break: anywhere;
}

.src-components-page-url-details-___page-url-details__url-history-list___lWNgZ {
  list-style-type: none;
  margin-left: 0;
  padding-left: 0;
}

.src-components-page-url-details-___page-url-details__url-scheme___pKmau {
  display: inline-block;
  width: 6em;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-url-details/page-url-details.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;;GAEC;EACD,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ","sourcesContent":[".page-url-details {\n  margin: 0.25em 0 0;\n  padding: 0 1em;\n}\n\n.page-url-details summary {\n  cursor: pointer;\n  margin-left: -1em;\n}\n\n.page-url-details ins {\n  font-weight: bold;\n  background: none !important;\n}\n\n.page-url-details a {\n  /*\n    Links here are full URLs are can sometimes have no good line break points.\n  */\n  line-break: anywhere;\n}\n\n.url-history-list {\n  list-style-type: none;\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.url-scheme {\n  display: inline-block;\n  width: 6em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-url-details": `src-components-page-url-details-___page-url-details__page-url-details___YeOQb`,
	"pageUrlDetails": `src-components-page-url-details-___page-url-details__page-url-details___YeOQb`,
	"url-history-list": `src-components-page-url-details-___page-url-details__url-history-list___lWNgZ`,
	"urlHistoryList": `src-components-page-url-details-___page-url-details__url-history-list___lWNgZ`,
	"url-scheme": `src-components-page-url-details-___page-url-details__url-scheme___pKmau`,
	"urlScheme": `src-components-page-url-details-___page-url-details__url-scheme___pKmau`
};
export default ___CSS_LOADER_EXPORT___;
